import Modal from '@/components/ui/Modal';
import Button from '@/components/ui/Button';
import type { PlanListItem } from '@/api/plansService';

interface PlanDeleteModalProps {
  plan: PlanListItem | null;
  onClose: () => void;
  onDelete: (id: string) => Promise<void>;
  onArchive: (id: string) => void;
}

const PlanDeleteModal = ({ plan, onClose, onDelete, onArchive }: PlanDeleteModalProps) => {
  const followers = 0;
  const blocked = followers > 0;

  return (
    <Modal open={Boolean(plan)} onClose={onClose} title="Supprimer le plan" size="md">
      {plan && (
        <>
          <div className="space-y-4 px-6 py-5">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Supprimer «&nbsp;<span className="font-semibold">{plan.displayName}</span>&nbsp;» ? Le plan et sa
              séquence de cycles seront supprimés. Les cycles eux-mêmes restent en bibliothèque.
            </p>
            <ul className="space-y-1 text-sm text-gray-500">
              <li>{plan.cyclesCount} cycle(s) retiré(s) de la séquence.</li>
              <li>{followers} utilisateur(s) suivent ce plan.</li>
            </ul>
            {blocked && (
              <p className="rounded-lg bg-warning-500/10 px-3 py-2 text-sm text-warning-600">
                Des athlètes suivent ce plan — la suppression est bloquée. Archivez-le à la place.
              </p>
            )}
          </div>
          <div className="flex justify-end gap-2 border-t border-gray-200 px-6 py-4 dark:border-gray-800">
            <Button variant="ghost" onClick={onClose}>
              Annuler
            </Button>
            <Button variant="secondary" onClick={() => onArchive(plan.id)}>
              Archiver
            </Button>
            <Button
              variant="danger"
              disabled={blocked}
              onClick={() => onDelete(plan.id).catch(() => undefined)}
            >
              Supprimer
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default PlanDeleteModal;
